import { ResolveFn } from '@angular/router';
import { MenuLinkRapidiInterface } from '../models/interfaces/menu-link-rapidi.interface';
import { inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { MenuLinkRapidiStore } from '../store/menu-link-rapidi.store';

export const homeResolver: ResolveFn<MenuLinkRapidiInterface | null> = (route, state) => {
  const httpClient = inject(HttpClient);
  const menuLinkRapidiStore = inject(MenuLinkRapidiStore);
  const url = `/${environment.CONTEXT_AUTORIZZAZIONI}/user/home`;
  const baseUrl = signal<string>(`${environment.ENV !== 'local' ? environment.BASE_URL : ''}`);

  return httpClient.get<MenuLinkRapidiInterface>(`${baseUrl()}${url}`, { withCredentials: true })
    .pipe(
      tap((res) => {
        menuLinkRapidiStore.saveMenuLinkRapidiCompleta(res);
      }), catchError((error) => {
        console.error('[homeResolver] Error fetching menu & link rapidi:', error);
        return of(null); 
      })
    );

}